export default {
    funeralList: [],
    funeralListCount: 0,
}